import logoPersonal from '../../images/Personalquadrado.png'
import Collapsible from 'react-collapsible';
import Arrow from '../../images/arrow.png'
import { FloatingWhatsApp } from '@carlos8a/react-whatsapp-floating-button';
import logo from '../../images/repLogo.png'
import './personal.css'

export function Personal() {
    return (
        <>
            <header id='personal-header'>
                <div className='header-logo-container'>
                    <img src={logoPersonal} className='header-logo' alt="logo escrito Personal André Maciel" />
                    <input type='checkbox' className='checkbox-menu' id='checkbox-menu'/>
                    <ul className='header-menu'>
                        <li><a href='#personal-header'>Início</a></li>
                        <li><a href='#modes'>Modalidades</a></li>
                        <li><a href='#locals'>Locais</a></li>
                    </ul>
                    <label htmlFor='checkbox-menu' className="img-menu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>
                </div>
            </header>

            <div className='header-title'>
                    <h2>Treinamento personalizado em Santos para todas as idades, foco em treinamento funcional e boxe</h2>
                    <h2>Faça uma aula experimental</h2>
            </div>

            <div className='card' id="modes">
                <h2>Modalidades</h2>
                <div className="faq">
                    <Collapsible  trigger={<div className='faq-item'>
                        <h3 className='question'>Funcional</h3>
                        <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                        </div>}>
                        <p>Tem o objetivo de desenvolver as capacidades físicas de nosso corpo através de
                            movimentos naturais do mesmo. Foco em estabilidade, equilíbrio, força e coordenação.
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<div className='faq-item'>
                        <h3 className='question'>Boxe</h3>
                        <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                        </div>}>
                        <p>Modalidade esportiva que exercita o corpo todo, um jeito de se exercitar
                            enquanto aprende um hobby.
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<div className='faq-item'>
                        <h3 className='question'>Misto</h3>
                        <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                        </div>}>
                        <p>Ambas as aulas na mesma sessão juntando as qualidades de cada modalidade</p>
                    </Collapsible>
                </div>
            </div>

            <div className='card' id="locals">
            <h2>Onde podemos treinar</h2>
            <div className="faq">
                <Collapsible  trigger={<div className='faq-item'>
                    <h3 className='question'>Nosso espaço</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>Venha até nosso espaço e usufrua da nossa estrutura e equipamentos</p>
                </Collapsible>
                <Collapsible trigger={<div className='faq-item'>
                    <h3 className='question'>Sua casa</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>Seu prédio tem academia ou qualquer espaço de 3x3m podemos levar toda nossa experiência
                        para o conforto do seu lar.
                    </p>
                </Collapsible>
                <Collapsible trigger={<div className='faq-item'>
                    <h3 className='question'>Praia</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>Temos quilômetros de orla a disposição, vamos usar essa beleza natural para nos ajudar a exercitar</p>
                </Collapsible>
            </div>
        </div>
        <footer>
            <p>Personal André Maciel &copy; 2016</p>
        </footer>
        <div>
            <FloatingWhatsApp
                phoneNumber='5513988223735'
                accountName='República do Boxe' 
                avatar={logo}
                statusMessage='Disponível agora'
                initialMessageByServer='Olá, vamos treinar juntos'
                initialMessageByClient='Olá, tenho interesse nas aulas de personal.'
                startChatText='Marque uma aula agora'
                allowEsc={true} 
                allowClickAway={true}
            />
        </div>
        </>
    )
}